export const environment = {
  production: false,
  groupName: "--",
  apiUrl: "https://ert-api-dev.azure.chevron.com/api/v1",
  clientId: "08d765fe-c787-4f91-94d6-6d5f9abb436a",
  tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
};
